jQuery(document).ready(function(){

 // Test
  
                jQuery('.handy-test').click( function(){ 
            	console.log('click');
                  
                
                  jQuery.ajax({
                    url:  "https://partners-api.int.handy-internal.com/api/v1/orders/echo",
                 // url: "https://partners.services.handy.com/api/v1/orders/echo",          
                  contentType: 'application/json; charset=utf-8',
                  data:         
                  {
                  "HDY-PARTNER-ID":"partner_api_test",
                  "HDY-TIMESTAMP":"1525361611",	
                  "HDY-SIGNATURE":"ignored"                
                	},
                  
                  headers: {
      				'Access-Control-Allow-Headers': 'accept',
      				'Access-Control-Allow-Methods': 'GET',
                    'Access-Control-Allow-Origin': '*' 
                  },
                    
                  type: 'GET',
                  success: function(result) {
                	console.log ('R' + data);
                	},
                      error: function(error) {
                      console.log('E' +  JSON.stringify(error));
                      }
    
                  
                  });
              
             
              
                
             });  
  
  
  // ----
  
  
  /*
              jQuery('.handy-test').click( function(){ 
            	
                jQuery.get("https://partners.services.handy.com/api/v1/orders/echo",                 
                {
                  
                  "HDY-PARTNER-ID":"partner_name",
                  "HDY-TIMESTAMP":"1525361611",	
                  "HDY-SIGNATURE":"OF5xI0LbLXHkFBLyNa8l..XHk="
                  
                  
                
                }).always(function(data) { 
                
                  console.log('Response: ' + data);
                                    jQuery('.handy-response').html(data);

                });
              
              
             
              
                
             });  */
  
  
  // Order
  
              jQuery('.handy-order').click( function(){ 
            	
                jQuery.post("https://partners.services.handy.com/api/v1/orders",                 
                {
                  
                  "HDY-PARTNER-ID":"partner_name",
                  "HDY-TIMESTAMP":"1525361611",	
                  "HDY-SIGNATURE":"OF5xI0LbLXHkFBLyNa8l..XHk=",
                  
                  
  "user": {
    "id": "xzvdfhryhbdbe",
    "email": "example@handy.com",
    "first_name": "John",
    "last_name": "Doe",
    "phone_number": "9170000000"
  },
  "address": {
    "id": "sfgethrethrt",
    "address1": "1st street",
    "address2": "Apt 2",
    "city": "Queens",
    "state": "NY",
    "country": "US",
    "zipcode": "10001",
    "type": "RESIDENTIAL"
  },
  "order": {
    "partner_order_id": "110001023",
    "metadata": {},
    "products": [
      {
        "sku": "HANDY1234",
        "product_info": {
          "product_name": "A nice chair"
        },
        "order_details": {
          "quantity": 1,
          "delivery_date": "2018-07-26",
          "service_date": "2018-07-26",
          "service_datetime": "2018-05-02T22:21:49.000Z",
          "line_number": 1
        }
      }
    ]
  }
                  
                  
                
                }).always(function(data) { 
                
                  console.log('Response: ' + data);
                  jQuery('.handy-response').html(data);
                  
                });
              
              
             
              
                
             });
              
            
});